'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /Users/developer2/dev/per/perecruit/~/querystring-es3/index.js
// module id = 11
// module chunks = 0 1